import React, { useState } from 'react';
import { IEnergyManager } from '@vfit/consumer/providers';
import { Energy } from '@vfit/consumer/energy';

const EnergyManagerWrapper = () => {
  const initialEnergyManager: IEnergyManager = {};

  const [modalDetail, setModalDetail] = useState<IEnergyManager>(initialEnergyManager);

  if (typeof document !== 'undefined') {
    document.addEventListener('energyManagerNotificationEvent', (event) => {
      const { detail } = event as CustomEvent as { detail: IEnergyManager };
      setModalDetail({
        ...detail,
      });
    });
  }

  const resetModalStatus = () => {
    setModalDetail(initialEnergyManager);
  };
  if (!modalDetail?.showModal) return null;

  const handleCloseModal = () => {
    modalDetail?.onClose?.();
    resetModalStatus();
  };

  if (!modalDetail?.showModal) return null;

  return <Energy {...modalDetail} onClose={() => handleCloseModal()} />;
};

export default EnergyManagerWrapper;
